import { create } from "zustand";
import { FormsStoreSlice, createFormsStore } from "./forms.store";

export type FormsStoreUnion = FormsStoreSlice;

export const useFormsStore = create<FormsStoreUnion>((...args) => ({
	...createFormsStore(...args),
}));
